/**
 * @fileoverview ค้นหาลูกค้าฝั่ง server สำหรับ dropdown
 * @module utils/customerSearch
 *
 * ลูกค้ามีได้หลักหมื่นราย การดึงมาทั้งก้อน (page: 0) แล้วกรองในเครื่องทำให้หน้าเว็บอืดและ
 * dropdown ค้างตอนเปิด จึงเปลี่ยนมาค้นหาฝั่ง server ทีละหน้า ใช้คู่กับ prop `onSearch` ของ Select
 */

import { GET } from "../services/api";

export const CUSTOMER_SEARCH_PAGE_SIZE = 50;

/**
 * ดึงลูกค้าตามคำค้น (หน้าแรก 50 รายการ)
 * @returns {Promise<Array|null>} รายการลูกค้า หรือ null เมื่อยิงไม่สำเร็จ (ผู้เรียกควรคงรายการเดิมไว้)
 */
export const searchCustomerRows = async (keyword = "", params = {}) => {
    const result = await GET("admin/customers", {
        page: 1,
        page_size: CUSTOMER_SEARCH_PAGE_SIZE,
        data_search: keyword || "",
        ...params,
    });

    return result?.status ? result.data || [] : null;
};

/**
 * ปักหมุดลูกค้าที่ถูกอ้างถึงอยู่ (ที่เลือกไว้ในฟอร์ม / ของรายการที่กำลังเปิดดู) ไว้หัวรายการ
 * เพื่อให้โค้ดที่หาข้อมูลลูกค้าจาก options ด้วย find() ยังทำงานได้แม้ผลค้นหาปัจจุบันจะไม่มีรายนั้น
 */
export const mergeCustomerPins = (options = [], pins = []) => {
    const values = new Set((options || []).map((option) => option.value));
    const pinned = (pins || []).filter((pin) => pin?.value && !values.has(pin.value));

    return [...pinned, ...(options || [])];
};

/** เพิ่มลูกค้าเข้าชุดหมุด (ไม่ซ้ำ เก็บล่าสุดไว้ก่อน และจำกัดจำนวนกันบวมโดยไม่จำเป็น) */
export const addCustomerPin = (pins = [], option, max = 10) => {
    if (!option?.value) return pins || [];

    return [option, ...(pins || []).filter((pin) => pin.value !== option.value)].slice(0, max);
};
